import React, { useEffect, useRef } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaQuoteLeft } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import HeroImage from "../assets/HeroImage.webp";
import abooutUsImage from "../assets/AboutUsHome.webp";
import familyImage from "../assets/FamilyHome.webp";
import finacialHome from "../assets/FinancialHome.webp";
import mutualFunds from "../assets/mutualFunds.webp";
import WhyChooseUs from "../assets/whyChoose.webp";
import Review1 from "../assets/01.mp4"
import Review2 from "../assets/02.mp4"
import Review3 from "../assets/03.mp4"
import {
  FaWhatsapp,
  FaLinkedin,
  FaFacebook,
  FaYoutube,
  FaInstagram,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { Helmet } from "react-helmet";
import axios from 'axios';
import FAQSection from "./FAQSection ";
const Home = () => {
  const navigate = useNavigate();
  const videoRefs = useRef([]);
  const handleConsultationClick = () => {
    navigate("/contact");
  };

    useEffect(() => {
      wakeUpAPI();
    }, []);
  
    const wakeUpAPI = async () => {
      try {
        const response = await axios.get('https://sfa-blog.onrender.com/api/blogs?page=1&limit=1');
        // console.log('API woke up:', response.status);
      } catch (error) {
        // console.error('Error waking up API:', error.message);
      }
    };

  return (
    <>
      <section className="hero-section d-flex align-items-center py-5">
        <Helmet>
          <title>
           Expert Financial Managers & Advisors in Mumbai & Dombivli | Retirement & Investment Planning
          </title>
          <meta
            name="description"
            content="Looking for a financial agent near you? Our financial advisors, managers, and LIC agents in Mumbai & Dombivli provide trusted investment advice, expert financial strategies, wealth planning, SIPs, insurance, and retirement solutions. Book your free consultation today!"
          />
        </Helmet>

        <Container>
          <Row className="align-items-center">
            {/* Left Side: Image */}
            <Col md={6} className="p-0">
              <div
                className="hero-image"
                style={{
                  backgroundImage: `url(${HeroImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "300px",
                  borderRadius: "10px",
                  alt: "Family consulting a financial advisor in Dombivli for smart financial planning",
                }}
              ></div>
            </Col>

            {/* Right Side: Text + Button */}
            <Col md={6} className="text-center text-md-start">
              <h1 className="bold">Trusted Financial Advisors in Mumbai & Dombivli – Expert Investment Guidance</h1>
              <p className="lead">
                At Shatrunjay Financial Advisors, we believe financial planning should be simple and effective. Our mission is to help individuals, families, and businesses in Mumbai and Dombivli achieve financial success with confidence.
              </p>
              <p className="lead">
                We provide expert investment advice, financial strategies, and trusted personal finance solutions tailored to your goals. Whether you want to save taxes, grow wealth, protect your family, or plan retirement, our advisors and financial managers are here to guide you.
              </p>
              <Button
                variant="warning"
                size="lg"
                onClick={handleConsultationClick}
                style={{fontWeight:"bold"}}
              >
                Book Your Free Financial Consultation Today!
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* About Section */}
      <section className="pt-5 bg-light">
        <Helmet>
          <title>
            Shatrunjay Financial Advisors | Financial Advisors in Mumbai & Kalyan-Dombivli | Wealth Planning
          </title>
          <meta
            name="description"
            content="Trusted financial advisors in Mumbai & Kalyan-Dombivli. Expert tax saving, SIP, insurance & wealth planning. Book your free consultation today!"
          />
        </Helmet>
        <Container>
          <Row className="align-items-center">
            {/* Left Side: Image */}
            <Col md={6} className="text-center text-md-start">
              <img
                src={abooutUsImage}
                alt="Founders of Shatrunjay Financial Advisors in Mumbai offering personal finance solutions"
                className="img-fluid rounded shadow-lg"
                style={{ maxHeight: "350px", objectFit: "cover" }}
              />
            </Col>

            {/* Right Side: Content */}
            <Col md={6} className="text-center text-md-start">
              <h1
                className="fw-bold mb-3 text-center"
                style={{ color: "#3A0063" }}
              >
                About Us
              </h1>
              <h2
                className="fw-bold mb-3 text-center"
                style={{ color: "#3A0063" }}
              >
                Expert Financial Advisors in <br/> Mumbai & Dombivli
              </h2>
              <p className="lead">
                At <strong>Shatrunjay Financial Advisors</strong>, we believe financial planning should be simple and effective. Our mission is to help individuals, families, and businesses in Mumbai and Dombivli achieve financial success with confidence.
              </p>
              <p className="lead">
               We are a team of 50+ Personal financial advisors, LIC managers, and investment managers with years of experience in personal finance, tax planning, and wealth management. Clients trust us for expert financial strategies and trusted investment advice in Mumbai & Dombivli. Instead of selling generic products, we create plans that match your income, goals, and risk appetite.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/*  */}
     <section className="py-5">
      <Helmet>
        <title>
          Why Choose Us | Shatrunjay Financial Advisors – Expert Investment & Wealth Planning
        </title>
        <meta
          name="description"
          content="Choose Shatrunjay Financial Advisors for trusted financial guidance, expert investment advice, and personalized wealth management in Mumbai, Dombivli & Kalyan."
        />
      </Helmet>

      <Container>
        <Row className="align-items-center">
            {/* Left Side: Image */}
            <Col md={6} className="text-center text-md-start">
              <img
                src={WhyChooseUs}
                alt="Team of professional financial advisors and wealth managers in Mumbai & Dombivli offering trusted investment advice and smart financial planning."
                className="img-fluid rounded shadow-lg"
                style={{ maxHeight: "350px", objectFit: "cover" }}
              />
            </Col>

          {/* Right Side: Content */}
          <Col md={6} className="text-center text-md-start">
            <h2
              className="fw-bold mb-3 mt-3 text-center"
              style={{ color: "#3A0063" }}
            >
              Why Choose Us
            </h2>

            <p className="lead">
              Experienced financial advisors, investment advisors, wealth managers
              & LIC agents with 10+ years of expertise.
            </p>

            <p className="lead">
              With a client base of over <strong>5,000+</strong>, we have helped
              families across <strong>Mumbai, Dombivli, and Kalyan</strong> achieve
              their financial dreams and secure a stable future.
            </p>

            <p className="lead">
              Expert investment advice and wealth management solutions tailored to
              your needs.
            </p>

            <p className="lead">
              Services covering life insurance, health insurance, SIPs, retirement,
              tax planning, and personal finance.
            </p>

            <p className="lead">
              Local expertise in Mumbai, Dombivli & Kalyan — smart financial
              planning trusted by families and businesses alike.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
      {/* Services Section */}
      <section className="bg-light">
        <Helmet>
          <title>
            Shatrunjay Financial Advisors | Financial Advisors in Mumbai & Kalyan-Dombivli | Wealth Planning
          </title>
          <meta
            name="description"
            content="Trusted financial advisors in Mumbai & Kalyan-Dombivli. Expert tax saving, SIP, insurance & wealth planning. Book your free consultation today!"
          />
        </Helmet>
        <h1 className="text-center mb-4 fw-bold" style={{ color: "#3A0063" }}>
          Our Services
        </h1>
        <Row>
          {[
            {
              title: "Insurance Services",
              img: familyImage,
              description:
                "Secure your family’s financial future with our comprehensive insurance solutions, ensuring income protection and peace of mind in times of uncertainty.",
            },
            {
              title: "Financial Planning",
              img: finacialHome,
              description:
                "Strategic financial planning to help you manage wealth, achieve financial freedom, and live life on your own terms with confidence.",
            },
            {
              title: "Mutual Funds",
              img: mutualFunds,
              description:
                "Maximize your investments with our expert-driven mutual fund strategies, designed to generate higher returns while minimizing risks.",
            },
          ].map((service, index) => (
            <Col md={4} key={index} className="">
              <Card className="h-100 shadow-lg border-0">
                <Card.Img
                  variant="top"
                  src={service.img}
                  className="img-fluid"
                  alt="Financial Advisors in Mumbai & Kalyan-Dombivli | Wealth Planning"
                  style={{ height: "220px", objectFit: "cover" }}
                />
                <Card.Body className="text-center">
                  <Card.Title className="fw-bold">{service.title}</Card.Title>
                  <Card.Text className="text-muted">
                    {service.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </section>

      {/* Testimonials Section */}
      <section className="py-5 bg-light">
        <Helmet>
          <title>
            Shatrunjay Financial Advisors | Financial Advisors in Mumbai & Kalyan-Dombivli | Wealth Planning
          </title>
          <meta
            name="description"
            content="Trusted financial advisors in Mumbai & Kalyan-Dombivli. Expert tax saving, SIP, insurance & wealth planning."
          />
        </Helmet>

        <h1 className="text-center mb-4 fw-bold" style={{ color: "#3A0063" }}>
          What Our Clients Say
        </h1>

        <Row className="gy-4">
          {[
            {
              video: Review1,
            },
            {
              video: Review2,
            },
            {
              video: Review3,
            },
            ].map((testimonial, index) => (
              <Col md={6} lg={4} key={index}>
                <Card className="border-0 shadow-sm p-3 h-100">
                <Card.Body>
                  <FaQuoteLeft
                    style={{ color: "#3A0063" }}
                    className="fs-3 mb-2"
                  />

                  <video
                    ref={(el) => (videoRefs.current[index] = el)}
                    src={testimonial.video}
                    controls
                    controlsList="nodownload"
                    className="w-100 rounded"
                    preload="metadata"
                    onPlay={() => {
                      videoRefs.current.forEach((vid, i) => {
                        if (i !== index && vid) {
                          vid.pause();
                        }
                      });
                    }}
                  >
                    Your browser does not support the video tag.
                  </video>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </section>
      
      <section className="bg-light">
        <Helmet>
          <title>
            Shatrunjay Financial Advisors | Financial Advisors in Mumbai & Kalyan-Dombivli | Wealth Planning
          </title>
          <meta
            name="description"
            content="Trusted financial advisors in Mumbai & Kalyan-Dombivli. Expert tax saving, SIP, insurance & wealth planning. Book your free consultation today!"
          />
        </Helmet>
        <FAQSection/>
      </section>

      {/* Contact Section */}
      <section
        className="bg-white text-dark py-5"
        style={{
          borderRadius: "10px",
          marginBottom: "50px",
          boxShadow: "0 0 20px rgba(0,0,0,0.05)",
        }}
      >
        <Helmet>
          <title>
            Shatrunjay Financial Advisors | Financial Advisors in Mumbai & Kalyan-Dombivli | Wealth Planning
          </title>
          <meta
            name="description"
            content="Trusted financial advisors in Mumbai & Kalyan-Dombivli. Expert tax saving, SIP, insurance & wealth planning. Book your free consultation today!"
          />
        </Helmet>
        <Container style={{ marginBottom: "50px" }}>
          <h1 className="text-center mb-5 fw-bold" style={{ color: "#3A0063" }}>
            Get In Touch
          </h1>

          <Row className="mb-4">
            {/* Contact Info */}
            <Col md={6} className="text-center text-md-start mb-4 mb-md-0">
              <p>
                <FaEnvelope className="me-2" style={{ color: "#3A0063" }} />
                Email:{" "}
                <a
                  href="mailto:contact@shatrunjayfinance.com" target="_blank" rel="noopener noreferrer"
                  className="text-decoration-none text-dark fw-semibold"
                >
                  shatrunjay.fa@gmail.com
                </a>
              </p>
              <p>
                <FaPhone className="me-2" style={{ color: "#3A0063" }} />
                Phone:{" "}
                <a
                  href="tel:+917715880775" target="_blank" rel="noopener noreferrer"
                  className="text-decoration-none text-dark fw-semibold"
                >
                  +91 77158 80775
                </a>
              </p>
            </Col>

            {/* Social Media */}
            <Col md={6} className="text-center text-md-end">
              <div className="d-flex flex-wrap justify-content-center justify-content-md-end align-items-center gap-2">
                <Button
                  variant="outline-primary"
                  href="https://wa.me/917715880775"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    border: "1px solid #3A0063", // Customize style, color, thickness
                    borderRadius: "8px", // Optional: rounded corners
                  }}
                >
                  <FaWhatsapp style={{ color: "#3A0063" }} />
                </Button>
                <Button
                  variant="outline-primary"
                  href="https://www.linkedin.com/company/shatrunjay-financial-advisors/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    border: "1px solid #3A0063", // Customize style, color, thickness
                    borderRadius: "8px", // Optional: rounded corners
                  }}
                >
                  <FaLinkedin style={{ color: "#3A0063" }} />
                </Button>
                <Button
                  variant="outline-primary"
                  href="https://www.facebook.com/share/1GfFsgm11J/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    border: "1px solid #3A0063", // Customize style, color, thickness
                    borderRadius: "8px", // Optional: rounded corners
                  }}
                >
                  <FaFacebook style={{ color: "#3A0063" }} />
                </Button>
                <Button
                  variant="outline-primary"
                  href="https://youtube.com/@shatrunjayfinancialadvisor4925?si=TroU0brMQJXpMCAf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    border: "1px solid #3A0063", // Customize style, color, thickness
                    borderRadius: "8px", // Optional: rounded corners
                  }}
                >
                  <FaYoutube style={{ color: "#3A0063" }} />
                </Button>
                <Button
                  variant="outline-primary"
                  href="https://www.instagram.com/financewithshatrunjay?igsh=MXFubXp6ZjB3ODh1bg=="
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    border: "1px solid #3A0063", // Customize style, color, thickness
                    borderRadius: "8px", // Optional: rounded corners
                  }}
                >
                  <FaInstagram style={{ color: "#3A0063" }} />
                </Button>
                <Button
                  style={{ backgroundColor: "#3A0063" }}
                  onClick={handleConsultationClick}
                >
                  Contact Us
                </Button>
              </div>
            </Col>
          </Row>

          <Row className="align-items-start">
            {/* Address */}
            <Col md={5} className="mb-4 mb-md-0">
              <div className="p-4 border rounded shadow-sm d-flex">
                <FaMapMarkerAlt
                  size={24}
                  className="me-3 mt-1"
                  style={{ color: "#3A0063" }}
                />
                <div>
                  <h5 className="fw-bold  mb-2" style={{ color: "#3A0063" }}>
                    Office Address
                  </h5>
                  <address className="mb-0 text-dark">
                    <strong>Shatrunjay Financial Advisors</strong>,
                    <br />
                    Office no. 3, Sant Gyaneshwar Krupa,
                    <br />
                    Sant Namdeo Path, Gograswadi,
                    <br /> Dombivli (E), Maharashtra - 421201, India
                  </address>
                </div>
              </div>
            </Col>

            {/* Map */}
            <Col md={7}>
              <div
                className="rounded shadow-sm border"
                style={{ minHeight: "250px", overflow: "hidden" }}
              >
                <iframe
                  title="Shatrunjay Financial Advisors"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.592967500272!2d73.09252687466847!3d19.212972447659258!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be79550e8620fdf%3A0xa31e5d95c2e4f2ba!2sShatrunjay%20Financial%20Advisors!5e0!3m2!1sen!2sin!4v1753619390384!5m2!1sen!2sin"
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Home;
